// generic functions
import { truncateString } from '../functions/truncateString'

// graphql components
import { fetchClientContactByClientContactId } from '../graphqlCompnents/DJT/fetchClientContactByClientContactId.jsx';

// PDF
import { callAddFont } from '../Arial Narrow Bold-normal'
import jsPDF from 'jspdf';
import { DjtPdfTemplate } from '../DjtPdfTemplate';
import { renderToStaticMarkup } from 'react-dom/server';
import { fetchDailyJobTicketById } from '../graphqlCompnents/DJT/fetchDailyJobTicketById.jsx';
import { alphaNumeric } from '../functions/random'

import { uploadBlobToS3 } from '../AWS/S3/UploadBlobToS3.jsx'
// import { pushFileToQB } from '../QuickBooks/pushFileToQuickBooks.jsx'
// import { uploadAttachmentFromS3ViaProxy } from "../QuickBooks/qboClient.jsx";
import { uploadAttachmentFromS3ViaProxy } from "../QuickBooks/qboClient.jsx";
import { updateDJTAttachedPDF } from '../graphqlCompnents/DJT/updateDJTAttachedPDF.jsx'

// Register the font once per page load. Registering it inside generatePdf added
// another handler every time a DJT was queued, which could make PDFs larger
// over the course of a session.
jsPDF.API.events.push(["addFonts", callAddFont]);

async function fetchContact(djtClientContactId) {
  const contact = await fetchClientContactByClientContactId(djtClientContactId);

  return contact
}

export const renderTemplateToHTML = async (djtId) => {

  const djtProps = await fetchDailyJobTicketById(djtId)

  const updatedLabor = djtProps?.djtLabor?.items?.map(item => {
    // If isTempLabor is true, then we perform our little "transformation".
    if (item.isTempLabor) {
      return {
        ...item, // Spread the existing properties (just in case there are others we care about)
        teamMember: { ...item.tempEmployee, goesBy: '' }, // Replace teamMember with tempEmployee
      };
    }
  
    // If isTempLabor is false, we keep the item unchanged.
    return item;
  });

  let clientContact = await fetchContact(djtProps.djtClientContactId)
  
  const doShowHours = djtProps?.showLaborHours||false
  const mergeMaterialEquipment = djtProps?.mergeMaterialEquipment
  const equipmentItems = djtProps?.djtEquipment?.items
  const materialItems = djtProps?.djtMaterial?.items
  let equipmentItemsToDisplay = equipmentItems
  let equipmentItemsToDisplayContinued = []
  let materialItemsToDisplay = []
  let materialItemsTotalToDisplay = 0
  let equipmentItemsTotalToDisplay = 0
  if (mergeMaterialEquipment===true) {
    if (materialItems?.length>0) {
      materialItems.forEach(material => {
        const equipmentObj = {
          billableDescription: material?.description,
          quantity: material?.quantity,
          totalBilled: material?.totalPrice,
          unitId: '',
          unitCode: '',
        }
        equipmentItemsToDisplay.push(equipmentObj)
      })
    }

    equipmentItemsTotalToDisplay = Number(djtProps?.djtEquipmentTotal) + Number(djtProps?.djtMaterialTotal)
  } else {
    materialItemsToDisplay = materialItems
    equipmentItemsTotalToDisplay = djtProps?.djtEquipmentTotal
    materialItemsTotalToDisplay = djtProps?.djtMaterialTotal
  }

  // split on daily jib ticket summary

  // console.info('equipmentItemsToDisplay: ', equipmentItemsToDisplay)
  // console.info('equipmentItemsToDisplayContinued: ', equipmentItemsToDisplayContinued)
  const elementToRender = <DjtPdfTemplate 
    date={djtProps?.djtDate}
    po={djtProps?.djtPO?.po}
    djtNotes={djtProps?.djtNotes}
    client={djtProps?.djtClient?.contactCompany || djtProps?.djtClient?.qbCompany}
    location={truncateString(djtProps?.djtLocation, 30)}
    // contact={djtProps?.djtClient?.contactName}
    contact={clientContact?.name||null}
    // contactEmail={djtProps?.djtClient?.contactEmail}
    contactEmail={truncateString(clientContact?.email||null, 30)}
    // phone={djtProps?.djtClient?.contactPhone}
    phone={clientContact?.phone||null}
    billingEmail={truncateString(djtProps?.djtClient?.qbEmail||null, 30)}
    // laborItems={(doShowHours) ? djtProps?.djtLabor?.items : []}
    laborItems={(doShowHours) ? updatedLabor : []}
    laborItemsTotal={djtProps?.djtLaborTotal}
    // equipmentItems={djtProps?.djtEquipment?.items}
    equipmentItems={equipmentItemsToDisplay}
    equipmentItemsContinued={equipmentItemsToDisplayContinued}
    // equipmentItemsTotal={djtProps?.djtEquipmentTotal}
    equipmentItemsTotal={equipmentItemsTotalToDisplay}
    // materialItems={djtProps?.djtMaterial?.items}
    materialItems={materialItemsToDisplay}
    // materialItemsTotal={djtProps?.djtMaterialTotal}
    materialItemsTotal={materialItemsTotalToDisplay}
    djtTotalBilled={djtProps?.djtTotalBilled}
    // pagebreakVerticalSpacer={pagebreakVerticalSpacer}
  />

  const renderedHTML = await renderToStaticMarkup(elementToRender)

  return renderedHTML
}

export const generatePdf = async (
  djt,
  _token,              // kept for backwards-compatibility, no longer used
  environment,
  doDownloadPdf,
  doUploadPdf,
  identityId
) => {
  const djtId = djt.id;
  const djtDate = djt.djtDate;
  const qbEnv = environment ? environment : "sandbox";
  const downloadPdf = !!doDownloadPdf;
  const uploadPdf = !!doUploadPdf;

  const renderedHTML = await renderTemplateToHTML(djtId);

  const doc = new jsPDF({
    orientation: "p",
    unit: "px",
    format: "letter",
    hotfixes: ["px_scaling"],
  });
  doc.setFont('Arial Narrow Bold', 'normal');

  const randomString = alphaNumeric(6);
  const filename = ("DJT-" + djtDate + "-" + randomString + ".pdf").replace(" ", "");

  return new Promise((resolve) => {
    // If the HTML render fails, the callback never runs. This catch makes
    // sure the promise still resolves and the status modal can't hang.
    Promise.resolve(
      doc.html(renderedHTML, {
        callback: async (doc) => {
          let processPdfResults = null;
          try {
            if (downloadPdf) doc.save(filename);

            if (uploadPdf) {
              const blobPDF = new Blob([doc.output("blob")], { type: "application/pdf" });
              console.info(`DJT PDF ${filename}: ${(blobPDF.size / 1024).toFixed(0)} KB`);

              const bucket = "qb-invoice-attachments-prod";
              const result = await uploadBlobToS3({
                file: blobPDF,
                filename,
                filetype: "application/pdf",
                bucket,
                identityId,
              });

              const s3Key = `protected/${result.identityId}/${result.key}`;
              processPdfResults = await uploadAttachmentFromS3ViaProxy({
                qbenv: qbEnv,
                bucket,
                key: s3Key,
                fileName: result.fileName,
                fileType: "application/pdf",
                identityId: result.identityId,
              });

              const attachableObjId = processPdfResults?.attachable?.Id;
              if (attachableObjId) {
                await updateDJTAttachedPDF(djtId, attachableObjId);
              } else {
                console.error("No attachable Id returned from QBO upload", processPdfResults);
              }
            }
          } catch (e) {
            console.error("generatePdf upload failed:", e);
            processPdfResults = null;
          }
          resolve(processPdfResults);
        },
      })
    ).catch((e) => {
      console.error("generatePdf render failed:", e);
      resolve(null);
    });
  });
};